import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Logout } from './module';

const initialState = {
    status: "idle",
    ActionStatus: "",
    errorMessage: "",
    LogoutUrl:""
};

export const LogoutAsync = createAsyncThunk(
    'logout/Logout',
    async (index, ThunkAPI) => {
        const response = await Logout();
        return response;
    }
);

export const LogoutAsyncSlice = createSlice({
    name: 'logout',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(LogoutAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(LogoutAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(LogoutAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            state.curlocation = action.payload;

            if(action.payload && action.payload.Status === 'OK'){
                state.LogoutUrl=action.payload.Data.LogoutUrl
                setTimeout(() => {
                    window.location.replace(action.payload.Data.LogoutUrl);
                }, 100);

            }
        });
    }
});

export default LogoutAsyncSlice.reducer;
